import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Spacer from "Components/Spacer";
import { Button, ButtonWrapper } from "ds/Button";
import Modal from "ds/Modal";

export const RevokeModal = ({ email, isOpen, setIsOpen, onAccept }) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => {
        setIsOpen(false);
      }}
      handleClose={() => {
        setIsOpen(false);
      }}
      id="invitation-revoke-modal"
    >
      <Typography.Title tag="h2">
        {intl.formatMessage({ id: "invitation.revokeModalTitle" })}
      </Typography.Title>
      <Typography.BodyText>
        {intl.formatMessage(
          {
            id: "invitation.revokeModalBody"
          },
          { email }
        )}
      </Typography.BodyText>
      <Spacer mt="40px">
        <ButtonWrapper justifyContent="end">
          <Button
            analyticId="cancel"
            variant="outline"
            onClick={() => {
              setIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button onClick={onAccept} analyticId="accept">
            Accept
          </Button>
        </ButtonWrapper>
      </Spacer>
    </Modal>
  );
};
